import { useLanguage, t } from "../../../i18n";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import { HiOutlineShieldCheck, HiOutlineLockClosed, HiOutlineCheckBadge } from "react-icons/hi2";
import ROUTES from "../../../config/routes";
import "./TrustVerifiedSection.css";
export default function TrustVerifiedSection() {
  useLanguage();
  const navigate = useNavigate();
  return <section className="bb-trust-section">
      <Row className="align-items-center g-4">
        <Col lg={7}>
          <div className="bb-trust-section__content">
            <div className="bb-trust-section__badge">
              <HiOutlineShieldCheck />{t("Safety and Transparency")}

            </div>

            <h2 className="bb-trust-section__title">{t("We are building BaytBuddy to support more informed and responsible room discovery")}

            </h2>

            <p className="bb-trust-section__description">{t("BaytBuddy encourages users to create complete profiles and share clear listing information to support better decisions on the platform. Additional trust and verification features are planned for future phases as the platform grows.")}

            </p>

            <div className="bb-trust-section__points">
              <div className="bb-trust-section__point">
                <HiOutlineCheckBadge />
                <span>{t("Stronger profile credibility for serious users")}</span>
              </div>

              <div className="bb-trust-section__point">
                <HiOutlineShieldCheck />
                <span>{t("Safer listing and connection experience")}</span>
              </div>

              <div className="bb-trust-section__point">
                <HiOutlineLockClosed />
                <span>{t("Better trust framework for future platform growth")}</span>
              </div>
            </div>

            {/* <Button
               className="bb-trust-section__btn"
               onClick={() => navigate(ROUTES.VERIFICATION_INFO)}
              >
               Learn More
              </Button> */}
          </div>
        </Col>

        <Col lg={5}>
          <div className="bb-trust-section__visual">
            <div className="bb-trust-section__visual-card bb-trust-section__visual-card--primary">
              <HiOutlineShieldCheck />
              <div className="bb-trust-section__visual-title">{t("Profile Completion First")}</div>
              <p>{t("Users must complete their profile before they can connect with listers.")}

              </p>
            </div>

            <div className="bb-trust-section__visual-card">
              <HiOutlineCheckBadge />
              <div className="bb-trust-section__visual-title">{t("Clearer Room Details")}</div>
              <p>{t("Structured listings help users understand what they are exploring before taking the next step.")}</p>
            </div>

            <div className="bb-trust-section__visual-card">
              <HiOutlineLockClosed />
              <div className="bb-trust-section__visual-title">{t("More Features Ahead")}</div>
              <p>{t("Additional trust and verification systems are planned as BaytBuddy evolves.")}</p>
            </div>
          </div>
        </Col>
      </Row>
    </section>;
}
